import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/active-management/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <Navigate to="/active-management/interval" />
}
